export default "<img class=\"image-media\" [src]=\"src\" [alt]=\"title\" (load)=\"onContentLoaded()\" [@fade]=\"visualState\">\r\n\r\n"